<template>
    <div class="w1200">
        <div v-if="downFile_progress" class="down-progress" style="
				position: fixed;
				bottom: 0px;
				background: #1296DB;
				right: 0;
				left: 0;
				padding: 20px;
				box-sizing: border-box;
				z-index: 10;
				text-align: center;
				font-weight: bold;
				color: #fff;
				font-size: 26px;
			">
            文件下载中，请稍等...
            <el-progress :text-inside="true" :stroke-width="26" :percentage="downFile_progress" status="success"></el-progress>
        </div>

        <div class="title" v-loading="loading">
            <div>
                <span>彩种:</span>
                <div>
                    <span v-for="(item, index) in lotteryList" :key="index" :class="{active:lotteryActive == index}" class="hoverAnimation" @click="
                            lotteryActive = index;
                            zhibiaoActive = 0;
                            priceActive = 0;
							queryZhibiao();
                        ">{{ item.dictLabel }}</span>
                </div>
            </div>
            <div>
                <span>指标:</span>
                <div>
                    <span v-for="(item, index) in zhibiaoList" :key="index" :class="{active:zhibiaoActive == index}" class="hoverAnimation" @click="
                            zhibiaoActive = index;
						  	query_period_price()
                        ">{{ item.dictLabel }}</span>
                </div>
            </div>
            <div>
                <span>
                    当前固定期数:
                    <b style="color: red">{{ period }}期</b>
                </span>
                <span>价格:</span>
                <div>
                    <span v-for="(item, index) in priceList" :key="index" :class="{active:priceActive == index}" @click="priceActive = index;getList()" class="hoverAnimation">
                        <template v-if="item.prices == 0">免费</template>
                        <template v-else> {{period}}期 {{item | handleStrillustrate}} </template>
                    </span>
                </div>
            </div>

        </div>
        <el-table v-loading="tableLoading" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }" border :data="list">
            <el-table-column type="index" width="60" label="序号">
                <template slot-scope="scope">
                    <template v-if="scope.$index <= 2 && listPagin.page == 1">
                        <img v-if="scope.$index == 0" src="@/assets/common/rank/1.gif">
                        <img v-if="scope.$index == 1" src="@/assets/common/rank/2.gif">
                        <img v-if="scope.$index == 2" src="@/assets/common/rank/3.gif">
                    </template>
                    <template v-else>
                        {{scope.$index + 1 + (listPagin.page - 1) * 10}}
                    </template>
                </template>
            </el-table-column>
            <el-table-column prop="number" label="期数"></el-table-column>
            <el-table-column prop="userName" label="缩水师">
                <template slot-scope="scope">
                    <div @click="view_history2(scope.row,(
							lotteryActive == 0 ? 'ssq':
							lotteryActive == 1 ? 'dlt':
							lotteryActive == 2 ? 'fcsd':
							lotteryActive == 3 ? 'pls':''
						))" style="cursor: pointer;color: #347CAF;font-weight: bold;">
                        {{scope.row.userName}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="target" label="指标" width="100">
            </el-table-column>
            <el-table-column prop="isUpdate" label="缩水单">
                <template #default="scope">
                    <div @click="look_shrink(scope.row)" style="cursor: pointer;color: #347CAF;font-weight: bold;">
                        下载查看 <i v-if="scope.row.loading" class="el-icon-loading"></i>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="achievment" width="100" label="成绩"></el-table-column>
            <el-table-column prop="coin" label="缩币"></el-table-column>
            <el-table-column prop="correctNum" label="正确次数"></el-table-column>
            <el-table-column prop="continuousRightMax" label="最大连对"></el-table-column>
            <el-table-column prop="currentContinuousRight" label="当前连对"></el-table-column>
            <el-table-column prop="continuousErrorMax" label="最大连错"></el-table-column>
            <el-table-column prop="currentContinuousError" label="当前连错"></el-table-column>
            <el-table-column prop="accuracy" label="正确率"></el-table-column>
        </el-table>

        <el-pagination v-if="listPagin.total > 9" style="padding-top:20px;text-align:right" background layout="prev, pager, next" @current-change="changePage" :page-size="listPagin.limit" :total="listPagin.total">
        </el-pagination>

        <popupPay ref="popupPay" @submit="(payParams,db) => createOrder(payParams,db)" />

    </div>
</template>

<script>

import { championList, preDictType, championQuery, championCriteria } from '@/api/swdgw.js'
import { queryLotteryType } from '@/api/common'

import popupPay from './components/popupPay.vue'

export default {
    components: {
        popupPay
    },
    filters: {
        handleStrillustrate (item) {
            if (!item.correctNumbers) return '';

            let itemScope = item.correctNumbers.split(',')

            if (itemScope.length == 1) {
                return `对${item.correctNumbers}期 ${item.prices}缩币`
            } else {
                let numMin = Math.min(...itemScope),
                    numMax = Math.max(...itemScope);
                return `对(${numMin}-${numMax})期 ${item.prices}缩币`
            }
        }
    },
    data () {
        return {
            lotteryList: [],
            lotteryActive: 0,

            zhibiaoList: [],
            zhibiaoActive: 0,

            priceList: [],
            priceActive: 0,

            period: '',  //期数

            loading: true,
            tableLoading: true,

            list: [],
            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },

            downFile_progress: '',

        };
    },
    mounted () {
        this.init()
    },
    methods: {
        // 查看缩水单
        look_shrink (row) {
            this.$confirm('您确定下载该缩水单吗?', '提示',).then(() => {
				row.loading = true
                this.queryDownloadFilePriceByRecordId(row)
            }).catch(() => { });
        },

        // 查询下载预测文件所需价格
        queryDownloadFilePriceByRecordId (row) {
            let { preIndexType, number, createUser, preType } = row
            let params = { preType, preIndexType, number, createUser, }
            this.$http.post('/stage-api/pre/record/queryDownloadFilePriceByRecordId', params).then(filePriceRes => {
                if (filePriceRes) {
                    let { price, orderNo } = filePriceRes.data;
                    if (orderNo) {
                        this.downLoadFile({ orderNo, coin: price }, row)
                    } else {
                        const payParams = {
                            uuid: new Date().getTime(),
                            money: price,
                            productAuthor: row.createUser,
                            payType: 'balancepay',
                            productId: filePriceRes.data.productId,
                            productModel: '0',
                            quantity: '1',
                            title: `${row.userName}-${row.number}-${row.target}-${row.achievment}`,
                            productSpecsId: filePriceRes.data.specsId,
                        }
                        if (price === 0) {
                            // 创建订单 - 下载
                            this.createOrder(payParams, row)
                        } else {
                            // 点击支付按钮-创建订单-下载
                            this.$refs.popupPay.init(payParams, row)
                        }
                    }
                }
            }).finally(() => {
                // row.loading = false
            })
        },

        // 创建订单
        createOrder (payParams, row) {
            /*
                money:支付金额
                productAuthor:商家ID
                payType:支付方式: wxpay=微信支付，alipay=阿里支付,balancepay=余额支付
                productId:商品ID
                productModel:缩水模块 商品所属模块：商品类别:0（预测缩水单商品），1（EXCEL专场商品），2（缩水软件特区商品）3（个人中心充值）4(个人中心提现) 5(投注站帮扶中心 )
                quantity:商品数量
                title:商品名称
                productSpecsId:商品规格ID
            */
            this.$http.post('/stage-api/order/v2/createOrder', payParams).then(res => {
                if (res.code === 200) {
                    this.downLoadFile({ orderNo: res.data.orderNo, coin: payParams.money }, row)
                }
            })
        },
        // 下载文件
        downLoadFile (params, item) {
            console.log('下载文件', JSON.parse(JSON.stringify(item)));
            let that = this;
            setTimeout(_ => {
                this.$http.get('/stage-api/pre/detail/zipDownload', {
                    params,
                    headers: { 'Authorization': 'Bearer ' + this.vuex_token },
                    responseType: 'blob',
                    onDownloadProgress: (progressEvent) => {
                        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                        that.downFile_progress = percentCompleted >= 100 ? false : percentCompleted
                    },
                }).then(downRes => {

					item.loading = false
					
                    if (downRes.code == 500) { return this.$message.error(res.msg) }

                    const mapArr = ['双色球', '大乐透', '福彩3D', '体彩排三']
                    let fileName = `${mapArr[that.lotteryActive]}-${item.number}期-${item.userName}-${item.target}.zip`

                    that.$utils.downloadFile(downRes, fileName, 'application/zip')
                })
            }, 1000)
        },




        view_history2 (item, preType) {
            this.$router.push({
                path: '/dating_viewHistory',
                query: {
                    shrinkId: item.shrinkId || item.createUser,
                    number: item.number,
                    userName: item.nickName,
                    preType,
                }
            })
        },
        // 查看历史记录
        view_history (item, preIndexType, preType, backNumber) {

            this.$router.addRoute({
                path: '/dating_viewHistory',
                name: 'dating_viewHistory', // 假设你有一个名字
                component: () => import('@/views/homePage/menu/suoshuidan_dating/components/viewHistory.vue')
            })

            const routeExists = this.$router.options.routes.some(route => route.name === 'dating_viewHistory');
            let trim = setInterval(() => {
                if (!routeExists) {
                    clearInterval(trim)
                    // 使用全局前置守卫来执行操作
                    this.$router.push({
                        path: '/dating_viewHistory',
                        query: {
                            item,
                            preIndexType,
                            preType,
                            backNumber
                        }
                    })
                }

            }, 100)

            // this.$refs.viewHistory.init(item, preIndexType, preType, backNumber)
        },
        init () {
            new Promise((resolve, reject) => {
                // 彩种
                queryLotteryType().then(res => {
                    this.lotteryList = res.data
                    resolve(res.data[0])
                })
            }).then(lotteryParams => {
                return new Promise((resolve, reject) => {
                    // 指标
                    preDictType(JSON.parse(lotteryParams.remark).child).then(res => {
                        this.zhibiaoList = res.data
                        resolve({
                            lotteryParams,
                            zhibiaoParams: res.data[0]
                        })
                    })
                })
            }).then(params => {
                let p_params = `${params.lotteryParams.dictValue}/${params.zhibiaoParams.dictValue}`
                this.request_period_price(p_params)
            })

        },
        // 查询某个彩种下的数据  (点击彩种)
        queryZhibiao () {
            this.loading = true
            let remark = JSON.parse(this.lotteryList[this.lotteryActive].remark).child
            preDictType(remark).then(res => {
                this.zhibiaoList = res.data

                let lottery_dictValue = this.lotteryList[this.lotteryActive].dictValue,
                    zhibiao_dictValue = this.zhibiaoList[this.zhibiaoActive].dictValue;
                this.request_period_price(`${lottery_dictValue}/${zhibiao_dictValue}`)

            })
        },
        // 查询某个指标下的数据  (点击彩种)
        query_period_price () {
            this.loading = true
            let lottery_dictValue = this.lotteryList[this.lotteryActive].dictValue,
                zhibiao_dictValue = this.zhibiaoList[this.zhibiaoActive].dictValue;
            this.request_period_price(`${lottery_dictValue}/${zhibiao_dictValue}`)
        },

        // 请求期数和价格
        request_period_price (p_params) {
            // 期数
            let qishu = championQuery(p_params),
                // 价格
                price = championCriteria(p_params);

            Promise.all([qishu, price]).then(res => {
                this.period = res[0].data[0].backNumber
                this.priceList = res[1].data

                this.loading = false

                this.getList()
            })
        },
        getList () {
            let params = {
                pageNum: this.listPagin.page,
                pageSize: this.listPagin.limit,

                backNumber: this.period,
                coin: this.priceList[this.priceActive].prices,
                preIndexType: this.zhibiaoList[this.zhibiaoActive].dictValue,
                preType: this.lotteryList[this.lotteryActive].dictValue,
            }
            championList('?' + this.$utils.getParamByJson(params)).then(res => {
                this.tableLoading = false
				res.rows.forEach(item => item.loading = false);
                this.list = res.rows;
                this.listPagin.total = res.total
            })
        },

        // 下载预测
        downLoad (imgsrc, name = new Date().getTime()) {
            //下载图片地址和图片名
            var image = new Image();
            // 解决跨域 Canvas 污染问题
            image.setAttribute("crossOrigin", "anonymous");
            image.onload = function () {
                var canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                var context = canvas.getContext("2d");
                context.drawImage(image, 0, 0, image.width, image.height);
                var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

                var a = document.createElement("a"); // 生成一个a元素
                var event = new MouseEvent("click"); // 创建一个单击事件
                a.download = name || "photo"; // 设置图片名称
                a.href = url; // 将生成的URL设置为a.href属性
                a.dispatchEvent(event); // 触发a的单击事件
            };
            image.src = imgsrc;
        },

        // 分页状态变化
        changePage (e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
    },
};
</script>

<style lang="scss" scoped>
.hoverAnimation {
    &:hover {
        cursor: pointer;
        font-size: 20px;
        width: -moz-max-content;
        width: max-content;
        transform-origin: center;
        transition: all 0.5s;
        position: relative;
        font-weight: bold;
        color: #3072cd;
        &::after {
            width: 100%;
            left: 0%;
        }
    }
    &:not(:hover) {
        transform: scale(1);
        &::after {
            width: 0%;
            left: 50%;
        }
    }
    &::after {
        content: '';
        display: block;
        border-bottom: 3px solid #3072cd;
        width: 0%;
        position: absolute;
        bottom: 5px;
        left: 50%;
        transition: width 0.5s linear, left 0.5s linear;
    }
}
.title {
    border: 1px solid rgba(0, 0, 0, 0.2);
    > div {
        display: flex;
        white-space: nowrap;
        align-items: flex-start;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        > div {
            display: flex;
            flex-wrap: wrap;
        }
        &:last-child {
            border-bottom: 0;
        }
        > span {
            margin-right: 20px;
        }
    }
    span {
        height: 50px;
        line-height: 50px;
        margin: 0 20px;
        display: inline-block;
        cursor: pointer;
        &.active {
            color: red;
        }
    }
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    /* 筛选区：去掉 nowrap，选项换行不再溢出屏幕 */
    .title {
        > div {
            flex-wrap: wrap;
            white-space: normal;
            padding: 6px 0;

            > span {
                margin-right: 10px;
                font-size: 13px;
            }

            > div {
                flex: 1;
                min-width: 0;
            }
        }

        span {
            height: auto;
            line-height: 1.8;
            margin: 0 8px;
            font-size: 14px;
        }
    }

    /* 分页：窄屏居中显示，避免右对齐被截断 */
    ::v-deep .el-pagination {
        padding-top: 16px !important;
        text-align: center !important;
    }

    /* 下载进度提示：窄屏缩小字号，避免文字超出屏幕 */
    .down-progress {
        font-size: 16px !important;
        padding: 12px !important;
    }
}
</style>
